//Load on every page
$(function () {
    var genericDeleteConfirmer = function () {
        $('.wrapper .deleteconfirm').on('click keypress', function (e) {
            if (e.type === 'click' || e.originalEvent.key === 'Enter') {
                if (!confirm('Are you sure you want to delete this item?')) {
                    e.preventDefault();
                    return false;
                }
            }
        });
    }
    genericDeleteConfirmer();
});

var addEvent = (function () {
    if (window.attachEvent) {
        return function (o, t, f) {
            o['e' + t + f] = f;
            o[t + f] = function () {
                o['e' + t + f](window.event);
            };
            o.attachEvent('on' + t, o[t + f]);
        }
    } else {
        return function (o, t, f) {
            o.addEventListener(t, f, false);
        }
    }
})();

/////////
class cPageNotificationHandler {
    constructor(notifications) {
        var self = this;
        this.notifications = notifications;
        $(window).load(function () {
            self.showPageNotifications();
        });
    }
    showPageNotifications() {
        var timeout = 0;
        if (this.notifications.length) {
            var notification = '';
            for (var i in this.notifications) {
                timeout += 2000; //ms per notification
                notification += this.notifications[i] + '<br>';
            }
            var elNotification = $('<div id="pagenotification">' + notification + '</div>');
            $('body').append(elNotification);
            elNotification.slideDown(500, function () {
                setTimeout(function () {
                    elNotification.fadeOut();
                }, timeout);
            });
        }
    }
}
